import { Pipe, PipeTransform } from '@angular/core';
import { KanbanColumn, KanbanCard } from '../models/kanban.model';

export function filterKanbanColumns(columns: KanbanColumn[], searchQuery: string): KanbanColumn[] {
  if (!columns || columns.length === 0) {
    return columns;
  }

  if (!searchQuery || searchQuery.trim() === '') {
    return columns;
  }

  const query = searchQuery.toLowerCase().trim();
  return columns.map(column => ({
    ...column,
    cards: (column.cards || []).filter(card => cardMatchesSearch(card, query)),
  }));
}

function cardMatchesSearch(card: KanbanCard, query: string): boolean {
    if (card.title?.toLowerCase().includes(query)) {
      return true;
    }

    if (card.description?.toLowerCase().includes(query)) {
      return true;
    }

    if (card.metadata?.skills && Array.isArray(card.metadata.skills)) {
      const hasSkillMatch = card.metadata.skills.some((skill: string) => 
        skill.toLowerCase().includes(query)
      );
      if (hasSkillMatch) {
        return true;
      }
    }

    if (card.metadata?.experience?.toLowerCase().includes(query)) {
      return true;
    }

    return false;
}

@Pipe({
  name: 'kanbanFilter'
})
export class KanbanFilterPipe implements PipeTransform {
  transform(columns: KanbanColumn[], searchQuery: string): KanbanColumn[] {
    return filterKanbanColumns(columns, searchQuery);
  }
}

